<template>
  <div id="tools">
    <div class="pd0 col btn-group">
      <button @click="sortyBy(0)" type="button" class="the-icons btn btn-light border-left">
        <i class="icon-sort"></i> قیمت
      </button>
      <button @click="sortyBy(1)" type="button" class="the-icons btn btn-light">
        <i class="icon-sort"></i> زمان پرواز
      </button>
      <button @click="sortyBy(2)" type="button" class="the-icons btn btn-light border-right">
        <i class="icon-sort"></i> ظرفیت
      </button>
      <button @click="sortyBy(3)" type="button" class="the-icons btn btn-light border-right">
        <i class="icon-sort"></i> نوع پرواز
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pdk-Flight-Sort",
  data() {
    return {
      open: false,
      message: "Accordion"
    };
  },
  methods: {
    sortyBy(typeCode) {
      let type = "unknown";
      switch (typeCode) {
        case 0:
          type = "totalAdultFare";
          break;

        case 1:
          type = "departureTime";
          break;

        case 2:
          type = "remainedCapacity";
          break;

        case 3:
          type = "ticketType";
          break;

        default:
          type = "airLineName";
          break;
      }

      this.$emit("sortBy", type);
    }
  }
};
</script>

<style>
.pd0 {
  padding: 0px;
}
</style>


